//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';

import {
  YoutubeIcon,
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  //NaverIcon,
} from '@cmp/images';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class FollowUs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, t } = this.props;
    const componentClasses = classNames(styles.FollowUs, {
      [className]: className,
    });
    const socialUrls = [
      {
        icon: <YoutubeIcon alt={t('alt_youtube')} />,
        url: t('url_youtube'),
      },
      {
        icon: <FacebookIcon alt={t('alt_facebook')} />,
        url: t('url_facebook'),
      },
      {
        icon: <TwitterIcon alt={t('alt_twitter')} />,
        url: t('url_twitter'),
      },
      {
        icon: <InstagramIcon alt={t('alt_instagram')} />,
        url: t('url_instagram'),
      },
      // May be needed later. Commenting the Naver blog link to revert for Vet portal as per request.
      // {
      //   icon: <NaverIcon alt={t('alt_naver')} />,
      //   url: t('url_naver'),
      // },
    ];
    const available_urls = socialUrls.filter(
      (urlElement) => urlElement.url != ''
    );
    return (
      <div className={componentClasses}>
        {t('landing_FollowUs') !== '' ? (
          <h1 className={styles.Title}>{t('landing_FollowUs')}</h1>
        ) : (
          ''
        )}
        <div className={styles.SocialBtnGroup}>
          {available_urls.map((social, key) => (
            <div key={key} className={styles.SocialBtn}>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.Btn}
              >
                {social.icon}
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(FollowUs);
